import { memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { type MemberDetails } from './ProjectGroup.types';
import { MembersListItem } from './MembersListItem';
import { type MembersListItemClassName } from './MembersListItem.types';

export const MembersListComponent = ({
    className,
    members,
    showMemberStatus,
    showRemoveMemberButton,
    onRemove,
}: {
    className?: { base?: string; memberslistItem?: MembersListItemClassName };
    members: MemberDetails[];
    showMemberStatus?: (member: MemberDetails) => boolean;
    showRemoveMemberButton?: (member: MemberDetails) => boolean;
    onRemove?: (member: MemberDetails) => void;
}) => (
    <div className={twMerge('flex flex-col gap-2.5', className?.base)}>
        {members.map(member => (
            <MembersListItem
                key={member.id}
                className={className?.memberslistItem}
                member={member}
                showStatus={showMemberStatus || (() => false)}
                onRemove={showRemoveMemberButton && showRemoveMemberButton(member) && onRemove ? onRemove : null}
            />
        ))}
    </div>
);

export const MembersList = memo(MembersListComponent);
